import React                      from 'react';
import PropTypes                  from 'prop-types';
import SocialShareBarShareContent from '../../SocialShareBar/SocialShareBarShareContent';

class AlbumDescriptionSocialShare extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state          = {
			tooltipIsShown: false,
		};
		this.onTooltipShown = this.onTooltipShown.bind(this);
	}

	/**
	 * @param {boolean} shown
	 */
	onTooltipShown(shown) {
		this.setState({tooltipIsShown: shown});
	}

	render() {
		const {album, baseClassName, isVisible} = this.props;
		const {tooltipIsShown}                  = this.state;

		const url = album.absoluteUrl || window.location.href;
		return (
			<div className={baseClassName + (isVisible ? '' : ' -hidden') + (tooltipIsShown && isVisible ? '' : ' -tooltip-hidden')}>
				<SocialShareBarShareContent
					gaPrefix="actor-video"
					shownShareButtons={{
						blogger:  true,
						facebook: true,
						reddit:   true,
						tumblr:   true,
						twitter:  true,
					}}
					isSeekableMedia={false}
					url={url}
					mediaId={album.id}
					title={album.title}
					showCopyLinkButton={true}
					copyLinkTooltipChanged={this.onTooltipShown}
					forceHideTooltip={!isVisible}
				/>
			</div>
		);
	}
}

AlbumDescriptionSocialShare.propTypes = {
	baseClassName: PropTypes.string,
	isVisible:     PropTypes.bool,
	album:         PropTypes.shape({
		absoluteUrl:        PropTypes.string,
		id:                 PropTypes.number,
		description:        PropTypes.string,
		contestPlace:       PropTypes.number,
		releaseDate:        PropTypes.string,
		duration:           PropTypes.string,
		hasAudio:           PropTypes.bool,
		totalViews:         PropTypes.number,
		title:              PropTypes.string,
		titleUrl:		    PropTypes.string,
		contestDetailsUrl:  PropTypes.string,
		likes:              PropTypes.number,
		dislikes:           PropTypes.number,
		isLiked:            PropTypes.bool,
		isDisliked:         PropTypes.bool,
		isFavorite:         PropTypes.bool,
		isVotingVisible:    PropTypes.bool,
		areCommentsVisible: PropTypes.bool,
	}),
};

export default AlbumDescriptionSocialShare;
